import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React from "react";
import "../NotesSection/NotesSection.scss";

interface Props {
  data: Array<{ name: string; date: Date; description: string }>;
}

const NotesSection: React.FC<Props> = ({ data }) => {
  return (
    <Box>
      {data.map((data, index) => (
        <div className="notessection">
          <Grid container spacing={2}>
            <Grid xs={12}>
              <h6 className="username">{data.name}</h6>
              <p className="creation_date">{data.date.toString()}</p>
              <p className="usernotes">{data.description}</p>
            </Grid>
          </Grid>
        </div>
      ))}
    </Box>
  );
};

export default NotesSection;
